<template>

  <div>
    <el-row style="padding-top: 1.2em; padding-bottom: 0.8em;" align="middle">
      <xolas-table
        ref="equiptable"
        table-ref="equiptable"

        title="Sites: Equipment"
        icon="fa fa-tools"

        url="/sites"

        :fields="fields"

        sort-field="siteName"

        search-placeholder="Site Ids, Site Names, Status, Site Group..."
        :layer-component="isTowerCo() ? 'siteEquip' : null"
        :layer-args="{ id: 'id' }">

        <template #equip-details="props">
          <el-row :gutter="9.63">
            <el-col :xs="24" :sm="24" :md="24" :lg="14" :hg="14">
              <site-card style="margin-top: 0.852em;" :site-data="props.rowData" use-leaflet map-left :no-map="!isDesktop" height="230px" />
           </el-col>

           <el-col :xs="24" :sm="24" :md="24" :lg="10" :hg="10">

             <el-card shadow="hover">

               <good-table
                 :cols="getCols(props.rowData.stats)"
                 :rows="getRows(props.rowData.stats)"

                 group
                 fixed-header
                 compact
                 striped

                 :sort="false"
                 :search="false"
                 :pagination="false"

                 theme="black-rhino"
                 max-height="285px"
             />

           </el-card>

          </el-col>

         </el-row>
        </template>

      </xolas-table>

    </el-row>

  </div>

</template>

<script>

import FormattingMixins from '@/mixins/FormattingMixins'

import SiteCard from '@/components/sites/SiteCard'

export default {
  mixins: [FormattingMixins],

  components: {
    SiteCard
  },

  props: {
    readOnly: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    getCols(stats) {
      return [
        {
          label: 'Type',
          field: 'type'
        },
        {
          label: 'Qty.',
          field: 'qty'
        },
      ]
    },

    getRows(stats) {
      return this.getRowsBy(stats, ['service', 'asset', 'ticket', 'request'])
    },

    getRowsBy(stats, type) {
      let row = []
      let total = 0

      for (let i = 0; i < type.length; i++) {
          let ch = []

          let keys = Object.keys(stats)

          for (let k = 0; k < keys.length; k++) {

            if (keys[k].startsWith(type[i])) {

              if (stats[keys[k]]) {

                let label = (keys[k].includes('rt')
                ? (keys[k].length === 3 ? keys[k].toUpperCase() : keys[k])
                : keys[k].substring(type[i].length, keys[k].length))

                  if (keys[k] === this.plural(type[i], 2)) {
                    total = stats[keys[k]]

                  } else {

                    ch.push({type:
                      (keys[k] === this.plural(type[i], 2)
                      ? this.titleCase(keys[k])
                      : label),
                      qty: stats[keys[k]]})
                  }  // if keys[k]...

              } // if stats[keys[k]]...

            } // if keys[k].startsWith...

          } // for keys

       if (ch.length > 0) {
         row.push({mode: 'span', label: this.titleCase(this.plural(type[i], 2)) + ' (' + total + ')', children: ch})
      }

      total = 0
      } // for type

      return row
    },


  },

  data () {
    return {
      owner: this.isTelco() ? Number(this.org().id) : null,
      fields: [
        /*        {
        name: '__checkbox',
        title: '#',
        titleClass: 'has-text-centered',
        dataClass: 'has-text-centered'
        }, */
        {
          name: '__slot:equip-details'
        },
      ]
    }
  }
}
</script>

<!-- Dev-parity: zero horizontal cell padding + tight line-height to match the
     legacy vuetable-2 render (dev <td> uses `12px 0`). -->
<style scoped>
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { padding-left: 0; padding-right: 0; }
::v-deep .el-table th .cell { white-space: normal; }
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { line-height: 1.25; }
</style>
